import axios, { AxiosResponse } from 'axios';

export default function searchInstrumentsAsync(apiUrl: string) {
  return function api<TResponse>(
    serialNumber: string | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/instruments/search/${serialNumber}`,
          method: 'GET',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
